import { render, staticRenderFns } from "./ConsumoFrigobar.vue?vue&type=template&id=6058b292&"
import script from "./ConsumoFrigobar.vue?vue&type=script&lang=js&"
export * from "./ConsumoFrigobar.vue?vue&type=script&lang=js&"
import style0 from "./ConsumoFrigobar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports